// extracted by mini-css-extract-plugin
export default {"Loading":"Loading_Loading__PeV66","Loading__loader":"Loading_Loading__loader__M3-f7"};